import { render } from "./BtnRequestOtp.vue?vue&type=template&id=595dcf4c"
import script from "./BtnRequestOtp.vue?vue&type=script&lang=js"
export * from "./BtnRequestOtp.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__